import PropTypes from 'prop-types';
import React from 'react';

import ReportLegend from '../ReportLegend';
import ReportSummary from '../ReportSummary';

const ApplicationStatusReport = React.memo(({ reportData }) => {
    // If no reportData or summary, render nothing
    if (!reportData) return null;

    return (
        <>
            <ReportLegend title="Application Status Report" />
            <ReportSummary summary={reportData.summary} />
        </>
    );
});

ApplicationStatusReport.propTypes = {
    reportData: PropTypes.shape({
        summary: PropTypes.string,
    }),
};

ApplicationStatusReport.defaultProps = {
    reportData: null,
};

export default ApplicationStatusReport;
